<template>
    <router-link :to="url" @click.stop.prevent class="text-primary hover:text-primary">{{ params.value }}</router-link>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    encrypt() {
      let id = this.params.data.id;
      return this.$secure.encrypt(id);
    },

    url () {
      return { name: 'reminder-show',  params: { id: this.encrypt } }
    }
  }
}
</script>
